import React, { useState, useEffect } from "react";
import { Route, Redirect } from 'react-router-dom';
import { HomePath } from './pages/Home';
import { authenticationService } from "./services";

function PrivateRoute({ component: Component, ...rest}) {
  const [ loggedIn, setLoggedIn ] = useState(authenticationService.currentUserValue);

  useEffect(() => {
    authenticationService.currentUser.subscribe(x => {
      setLoggedIn(authenticationService.currentUserValue);
    });
  }, []);

  return(
    <Route {...rest}
        render={props =>
            loggedIn ? (
                <Component {...props} user={loggedIn}/>
            ) : (
                <Redirect to={HomePath} />
            )
        }
    />
  );
}

export default PrivateRoute;
